var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketplaceEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 280,
    viewBox: "0 0 480 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 464,
    height: 264,
    rx: 14,
    fill: "#EBF9F4",
    stroke: "#33CD87",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 464,
    height: 44,
    rx: 14,
    fill: "#EBF9F4",
    stroke: "#33CD87",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 36,
    width: 464,
    height: 16,
    fill: "#EBF9F4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 30,
    r: 7,
    fill: "#33CD87"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 30,
    r: 7,
    fill: "#33CD87"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 30,
    r: 7,
    fill: "#33CD87"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 20,
    width: 340,
    height: 20,
    rx: 10,
    fill: "none",
    stroke: "#33CD87",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 68,
    width: 130,
    height: 184,
    rx: 8,
    fill: "none",
    stroke: "#33CD87",
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 68,
    width: 130,
    height: 84,
    rx: 8,
    fill: "#C8F0E1",
    stroke: "#33CD87",
    strokeWidth: 1.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 140,
    width: 130,
    height: 12,
    fill: "#EBF9F4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 164,
    width: 106,
    height: 8,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 180,
    width: 86,
    height: 6,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 194,
    width: 96,
    height: 6,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 208,
    width: 76,
    height: 6,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 222,
    width: 86,
    height: 6,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 68,
    width: 130,
    height: 184,
    rx: 8,
    fill: "none",
    stroke: "#33CD87",
    strokeWidth: 1.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 68,
    width: 130,
    height: 84,
    rx: 8,
    fill: "#C8F0E1",
    stroke: "#33CD87",
    strokeWidth: 1.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 140,
    width: 130,
    height: 12,
    fill: "#EBF9F4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 164,
    width: 106,
    height: 8,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 180,
    width: 70,
    height: 6,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 194,
    width: 96,
    height: 6,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 208,
    width: 56,
    height: 6,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 222,
    width: 86,
    height: 6,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 68,
    width: 130,
    height: 184,
    rx: 8,
    fill: "none",
    stroke: "#33CD87",
    strokeWidth: 1.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 68,
    width: 130,
    height: 84,
    rx: 8,
    fill: "#C8F0E1",
    stroke: "#33CD87",
    strokeWidth: 1.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 140,
    width: 130,
    height: 12,
    fill: "#EBF9F4"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 164,
    width: 106,
    height: 8,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 180,
    width: 90,
    height: 6,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 194,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 208,
    width: 66,
    height: 6,
    rx: 3,
    fill: "#C8F0E1"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 222,
    width: 86,
    height: 6,
    rx: 3,
    fill: "#C8F0E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceEmpty);
export default __webpack_public_path__ + "static/media/marketplace-empty.f81f5a08d27e77ea3937e53fee54865c.svg";
export { ForwardRef as ReactComponent };